import {useEffect, useMemo, useState} from 'react';
import useFetch from "v4/hooks/useFetch";
import {generateUrl} from "v4/services/api.service";

export default function useSearchFormInputs(searchRouteName, tab, shouldBypassForm = false) {
    const [{data, isLoading, isFinished}, fetchSearchForm] = useFetch();
    const [autoCompleteChoices, setAutoCompleteChoices] = useState({});

    useEffect(() => {
        if (!searchRouteName || shouldBypassForm) return;

        const fetchParams = {};
        if (!tab?.native_identifier) {
            fetchParams.tabId = tab.metadata?.tab_id;
        }
        fetchSearchForm({url: generateUrl(searchRouteName, fetchParams)});
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchRouteName, shouldBypassForm])

    const inputs = useMemo(() => data?.['hydra:member'] ?? {}, [data]);

    const flatInputs = useMemo(() => Object.values(inputs?.results ?? {}).map(({properties}) => properties).flat(), [inputs]);

    const flatInputsWithoutHidden = useMemo(() => Object.entries(inputs?.results ?? {}).filter(([id]) => id !== 'hidden').map(([, {properties}]) => properties).flat(), [inputs]);

    return {
        inputs,
        flatInputs,
        flatInputsWithoutHidden,
        state: {
            isLoading,
            isFinished,
        },
        autoCompleteChoices,
        setAutoCompleteChoices,
    };
}
